import React from "react";
import PropTypes from "prop-types";

import Social from "ui/PageElement/Social";

const Elements = ({ socials, organizationSlug, preview }) => {

  if (socials.length === 0) return null;

  return (
    <div className="social-elements">
      {socials.map((pageElement, index) => (
        <Social key={index} pageElement={pageElement} organizationSlug={organizationSlug} preview={preview} />
      ))}
    </div>
  );
};

Elements.propTypes = {
  socials: PropTypes.array,
  organizationSlug: PropTypes.string,
  preview: PropTypes.bool
};

export default Elements;
